<div class="app-shell" [class.chrome-hidden]="hideChrome">
  <app-header *ngIf="!hideChrome"></app-header>

  <div class="app-body" [class.chrome-hidden]="hideChrome">
    <aside class="app-sidebar" *ngIf="!hideChrome" [class.collapsed]="collapsed">
      <div class="sidebar-header">
        <button
          type="button"
          class="sidebar-toggle"
          (click)="toggleSidebar()"
          [matTooltip]="(collapsed ? 'NAV.EXPAND_SIDEBAR' : 'NAV.COLLAPSE_SIDEBAR') | translate"
          matTooltipPosition="after"
          [attr.aria-label]="(collapsed ? 'NAV.EXPAND_SIDEBAR' : 'NAV.COLLAPSE_SIDEBAR') | translate"
        >
          <mat-icon>{{ collapsed ? 'menu' : 'menu_open' }}</mat-icon>
        </button>
      </div>

      <nav class="sidebar-nav" [attr.aria-label]="'NAV.MAIN_NAVIGATION' | translate">
        <div class="nav-group" *ngFor="let group of navGroups">
          <p class="nav-group-label">{{ group.label | translate }}</p>

          <a
            *ngFor="let item of group.items"
            class="nav-link"
            [routerLink]="item.route"
            routerLinkActive="active"
            [matTooltip]="collapsed ? (item.label | translate) : ''"
            matTooltipPosition="after"
          >
            <span class="nav-link-icon">
              <mat-icon>{{ item.icon }}</mat-icon>
            </span>
            <span class="nav-link-text">{{ item.label | translate }}</span>
          </a>
        </div>
      </nav>

      <div class="sidebar-footer">
        <div
          class="sidebar-user"
          [matTooltip]="collapsed ? userName : ''"
          matTooltipPosition="after"
        >
          <span class="user-avatar-wrap">
            <span class="user-avatar" aria-hidden="true">{{ userInitials }}</span>
            <span class="user-status" aria-hidden="true"></span>
          </span>
          <span class="user-meta">
            <span class="user-name">{{ userName }}</span>
            <span class="user-role" *ngIf="userRole">{{ userRoleLabel }}</span>
          </span>
        </div>
      </div>
    </aside>

    <main class="app-content" [class.chrome-hidden]="hideChrome">
      <router-outlet></router-outlet>
    </main>
  </div>

  <div
    class="message-modals-backdrop"
    *ngIf="!hideChrome && isTeacherPortal && showLoginCarousel && currentAnnouncement"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'ANNOUNCEMENTS.TITLE' | translate"
  >
    <div class="message-carousel">
      <button
        type="button"
        class="carousel-nav carousel-nav-prev"
        *ngIf="hasMultipleAnnouncements"
        (click)="previousAnnouncement()"
        [attr.aria-label]="'ANNOUNCEMENTS.PREVIOUS' | translate"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <article class="message-modal-card">
        <header class="message-modal-card-header">
          <div class="message-modal-card-title">
            <mat-icon aria-hidden="true">campaign</mat-icon>
            <span>{{ 'ANNOUNCEMENTS.SINGLE' | translate }}</span>
            <span class="message-counter" *ngIf="hasMultipleAnnouncements">
              {{ currentAnnouncementIndex + 1 }} / {{ activeAnnouncements.length }}
            </span>
          </div>
          <button
            type="button"
            class="btn btn-ghost btn-icon message-modal-dismiss"
            (click)="closeLoginCarousel()"
            [attr.aria-label]="'ANNOUNCEMENTS.CLOSE' | translate"
          >
            <mat-icon>close</mat-icon>
          </button>
        </header>
        <div class="message-modal-card-body">
          <p>{{ currentAnnouncement.text }}</p>
        </div>
        <footer class="message-carousel-footer">
          <div class="carousel-dots" *ngIf="hasMultipleAnnouncements">
            <button
              type="button"
              class="carousel-dot"
              *ngFor="let announcement of activeAnnouncements; let i = index"
              [class.active]="i === currentAnnouncementIndex"
              (click)="goToAnnouncement(i)"
              [attr.aria-label]="('ANNOUNCEMENTS.GO_TO' | translate) + ' ' + (i + 1)"
            ></button>
          </div>
          <button type="button" class="btn btn-primary carousel-continue" (click)="closeLoginCarousel()">
            {{ 'ANNOUNCEMENTS.CONTINUE' | translate }}
          </button>
        </footer>
      </article>

      <button
        type="button"
        class="carousel-nav carousel-nav-next"
        *ngIf="hasMultipleAnnouncements"
        (click)="nextAnnouncement()"
        [attr.aria-label]="'ANNOUNCEMENTS.NEXT' | translate"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
